import { render, staticRenderFns } from "./OrdersScheduledPending.vue?vue&type=template&id=5a8798e2&scoped=true&"
import script from "./OrdersScheduledPending.vue?vue&type=script&lang=js&"
export * from "./OrdersScheduledPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8798e2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8798e2')) {
      api.createRecord('5a8798e2', component.options)
    } else {
      api.reload('5a8798e2', component.options)
    }
    module.hot.accept("./OrdersScheduledPending.vue?vue&type=template&id=5a8798e2&scoped=true&", function () {
      api.rerender('5a8798e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/OrdersScheduledPending.vue"
export default component.exports